<div class="project-frequencie-main-container" [formGroup]="form">
    <div class="frequencie-container">
        <span class="project-frequencie-main-container-title">{{'project_team_frequency_title' | translate}}</span>
        <div *ngFor="let frequency of projectFrequencies" 
            class="frequencie" 
            [ngClass]="{'active': frequency.uuid === form.get('frequency')?.value}"
            (click)="setFrequency(frequency.uuid)">
            <p-radioButton 
                [value]="frequency.uuid" 
                [label]="(frequency.name | titlecase)"
                formControlName="frequency"></p-radioButton>
            <div *ngIf="frequency.slug === 'weekly'" class="recomended-container">
                <span>{{'project_team_frequency_recomanded' | translate}}</span>
            </div>
        </div>
    </div>
    <div class="frequencie-container start-date">
        <span class="project-frequencie-main-container-title">{{'project_team_checkin_start_date_title' | translate}}</span>
        <div *ngFor="let date of kickOffDateList, let index = index" 
            class="frequencie"
            [ngClass]="{'active': date.value === form.get('checkinStartDate')?.value}"
            (click)="setKickOffDateRadioBtn(date.value)">
            <p-radioButton 
                formControlName="checkinStartDate"
                [value]="date.value" 
                [label]="date.label"></p-radioButton>
            <div *ngIf="index === 1" class="calendar-wrapper">
                <img class="calendar-icon" (click)="startDateCalendar?.toggle()" src="../../../../../assets/svg/m_info_icon_calendar.svg">
                <p-calendar
                    #startDateCalendar
                    id="projectStartDate"
                    formControlName="otherCheckinStartDate"
                    [showIcon]="false"
                    dateFormat="d MM y"
                    [showButtonBar]="true"
                    class="date-calendar"
                    (keydown.enter)="$event.preventDefault();$event.stopPropagation()">
                </p-calendar>
            </div>
        </div>
    </div>
</div>